import React from "react";
import "./styles.css";

export interface ProgressBarProps {
  totalSteps: number;
  currentStep: number;
  className?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ totalSteps, currentStep, className = "" }) => {
  return (
    <div className={`progress-bar ${className}`}>
      {Array.from({ length: totalSteps }, (_, index) => (
        <div
          key={index}
          className={`progress-bar-step ${currentStep >= index + 1 ? "active" : ""}`}
        />
      ))}
    </div>
  );
};

export default ProgressBar;

